var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHarbingerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 44.461,
    viewBox: "0 0 136 44.461",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6242",
    "data-name": "Group 6242",
    transform: "translate(-92 -149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16254",
    "data-name": "Path 16254",
    d: "M15.14,14.357c-2.742,3.4-7.2,4.969-11.484,6.383a2.687,2.687,0,1,1-1.606-5.116l.5-.166c2.577-.849,5.435-1.791,7.233-3.677C12.1,9.348,11.518,6.19,10.859,3.318c-.766-3.336,5.06-4.751,5.833-1.409.974,4.244,1.452,8.723-1.552,12.448m4.286,7.261C13.228,24.408,1.406,30.341,7.392,38c2.19,2.8-2.931,5.445-5.1,2.672-3.279-4.191-2.879-9.718.124-13.944,3.3-4.638,8.7-7.287,14.026-9.682,3.39-1.524,6.374,3.049,2.977,4.574",
    transform: "translate(92 149)",
    fill: "#e63946",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16255",
    "data-name": "Path 16255",
    d: "M250.279,38.667V32.1h6.182v6.567h3.5V22.359h-3.5v6.435h-6.182V22.359h-3.5V38.667Z",
    transform: "translate(-122.506 129.565)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16256",
    "data-name": "Path 16256",
    d: "M370.12,71.768c1.621,0,3.048-.727,3.394-1.741l.216,1.454h2.94V65.047c0-3.151-1.773-4.937-4.907-4.937-3.091,0-5.1,1.631-5.1,4.121h2.767c0-.992.756-1.543,2.162-1.543,1.189,0,1.838.573,1.838,1.653v.177l-3.026.243c-2.594.2-4,1.454-4,3.482a3.372,3.372,0,0,0,3.718,3.526m1.167-2.512c-1.017,0-1.492-.375-1.492-1.168,0-.705.519-1.036,1.967-1.168l1.686-.155v.6c0,1.256-.886,1.9-2.162,1.9",
    transform: "translate(-226.488 96.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16257",
    "data-name": "Path 16257",
    d: "M470.613,61.78a5.419,5.419,0,0,0-1.275-.155,2.9,2.9,0,0,0-2.853,1.807l-.173-1.631h-3.134v11h3.329V68.017c0-2.182,1.146-3.041,3.048-3.041h1.059Z",
    transform: "translate(-310.608 95.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16258",
    "data-name": "Path 16258",
    d: "M536.049,36.617l.173-1.41a3.859,3.859,0,0,0,3.394,1.7c3.07,0,5.21-2.27,5.21-5.686,0-3.592-1.923-5.994-4.95-5.994a4.366,4.366,0,0,0-3.632,1.653V20h-3.329V36.617Zm.216-5.576a2.563,2.563,0,0,1,2.637-2.755,2.514,2.514,0,0,1,2.572,2.755A2.514,2.514,0,0,1,538.9,33.8a2.563,2.563,0,0,1-2.637-2.755",
    transform: "translate(-371.227 131.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16259",
    "data-name": "Path 16259",
    d: "M638.567,24.116a1.91,1.91,0,1,0-1.356-.572,1.906,1.906,0,0,0,1.356.572m-1.643,12.738h3.329V25.835h-3.329Z",
    transform: "translate(-461.409 131.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16260",
    "data-name": "Path 16260",
    d: "M686.53,71.482V65.443a2.064,2.064,0,0,1,2.162-2.248c1.146,0,1.9.9,1.9,2.292v5.994h3.329v-6.81c0-2.887-1.492-4.562-4.064-4.562a3.975,3.975,0,0,0-3.307,1.5l-.216-1.146H683.2V71.482Z",
    transform: "translate(-501.859 96.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16261",
    "data-name": "Path 16261",
    d: "M779.03,65.628c0,3.306,2.1,5.576,5.122,5.576a4.205,4.205,0,0,0,3.264-1.3v1.432A2.4,2.4,0,0,1,784.8,73.87c-1.47,0-2.377-.727-2.443-1.961h-3.372c.3,3.129,2.529,5.047,5.836,5.047,3.7,0,5.922-2.38,5.922-6.325V60.317h-3.134l-.173,1.1a3.713,3.713,0,0,0-3.221-1.477c-3.048,0-5.188,2.336-5.188,5.686m3.351-.088a2.521,2.521,0,1,1,5.036,0,2.479,2.479,0,0,1-2.529,2.711,2.51,2.51,0,0,1-2.507-2.711",
    transform: "translate(-585.12 96.897)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16262",
    "data-name": "Path 16262",
    d: "M889.193,71.768c2.961,0,5.1-1.565,5.49-4.011h-3.048c-.237.793-1.123,1.256-2.377,1.256a2.2,2.2,0,0,1-2.464-2.138l7.847-.044v-.859c0-3.592-2.118-5.862-5.512-5.862-3.264,0-5.534,2.4-5.534,5.84a5.5,5.5,0,0,0,5.6,5.818m-.044-8.9a1.924,1.924,0,0,1,2.184,1.917h-4.5a2.093,2.093,0,0,1,2.312-1.917",
    transform: "translate(-676.047 96.751)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16263",
    "data-name": "Path 16263",
    d: "M990.576,61.78a5.42,5.42,0,0,0-1.275-.155,2.9,2.9,0,0,0-2.853,1.807l-.174-1.631H983.14v11h3.329V68.017c0-2.182,1.145-3.041,3.048-3.041h1.059Z",
    transform: "translate(-762.576 95.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16264",
    "data-name": "Path 16264",
    d: "M248.084,176.167a3.323,3.323,0,0,1,3.545,2.468H255.3c-.367-3.526-3.307-5.818-7.133-5.818-4.95,0-8.171,3.548-8.171,8.462,0,5,3.134,8.353,7.609,8.353a5.976,5.976,0,0,0,4.5-1.719l.195,1.477h3v-9.366h-7.522v3.129h4.237c-.151,1.7-1.319,3.151-3.957,3.151-2.551,0-4.367-1.631-4.367-4.914,0-3.151,1.491-5.223,4.388-5.223",
    transform: "translate(-116.616 -1.218)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16265",
    "data-name": "Path 16265",
    d: "M383.442,214.26a5.419,5.419,0,0,0-1.275-.155,2.9,2.9,0,0,0-2.853,1.807l-.173-1.631h-3.134v11h3.329V220.5c0-2.182,1.146-3.041,3.048-3.041h1.059Z",
    transform: "translate(-234.836 -37.107)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16266",
    "data-name": "Path 16266",
    d: "M438.859,218.577a5.957,5.957,0,1,0,5.966-5.818,5.62,5.62,0,0,0-5.966,5.818m3.351-.022a2.61,2.61,0,1,1,2.616,2.777,2.546,2.546,0,0,1-2.616-2.777",
    transform: "translate(-289.47 -35.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16267",
    "data-name": "Path 16267",
    d: "M549.076,215.287v5.73c0,1.807-.584,2.557-2.01,2.557-1.362,0-1.967-.793-1.967-2.6v-5.686H541.77v6.92c0,2.711,1.513,4.386,3.977,4.386a4.276,4.276,0,0,0,3.307-1.521l.216,1.234h3.134V215.287Z",
    transform: "translate(-378.924 -38.134)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16268",
    "data-name": "Path 16268",
    d: "M642.2,229.252h3.329v-6.391a4.488,4.488,0,0,0,3.5,1.41c3.221,0,5.08-2.512,5.08-5.994,0-3.548-2.1-5.686-5.1-5.686a4.059,4.059,0,0,0-3.5,1.7l-.173-1.344H642.2Zm3.351-10.8a2.563,2.563,0,0,1,2.637-2.755,2.761,2.761,0,0,1,0,5.51,2.563,2.563,0,0,1-2.637-2.755",
    transform: "translate(-466.221 -35.79)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarbingerLogo);
export default __webpack_public_path__ + "static/media/harbinger-logo.2c57bb2999aaad36c0b322428c6d58d9.svg";
export { ForwardRef as ReactComponent };